/**
 * Whether what the microphone heard is the voice's own speech coming back.
 *
 * A phone on speaker hears the reply as it plays, and echo cancellation does
 * not always take it out. Heard words that follow what was just said, mostly
 * in order, are the voice; anything else is the person, and stops it.
 */

const words = (text: string): string[] =>
  text
    .toLowerCase()
    .replace(/[^\p{L}\p{N}\s']/gu, ' ')
    .split(/\s+/)
    .filter(Boolean);

/** The longest run of `a` that appears in order in `b`. */
function inOrder(a: string[], b: string[]): number {
  const row = new Array<number>(b.length + 1).fill(0);
  for (let i = 1; i <= a.length; i++) {
    let prev = 0;
    for (let j = 1; j <= b.length; j++) {
      const keep = row[j]!;
      row[j] = a[i - 1] === b[j - 1] ? prev + 1 : Math.max(row[j]!, row[j - 1]!);
      prev = keep;
    }
  }
  return row[b.length]!;
}

export function isEcho(heard: string, spoken: readonly string[]): boolean {
  const h = words(heard);
  if (!h.length) return true;
  const s = words(spoken.join(' '));
  if (!s.length) return false;
  if (h.length === 1) return s.includes(h[0]!);
  return inOrder(h, s) / h.length >= 0.7;
}
